import moment from "moment/moment";
import date_icon from "../../../assets/images/date_icon.svg";
import { CSSProperties, FC, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import Calender from "../../../components/commons/calender";
import classes from "./style.module.scss";
import CalendarDayWidget from "../../commons/ono-calendar-v2/calendar_days_widget";
import ONOCalendarV2 from "../../commons/ono-calendar-v2/ono_calendar_v2";

type TSelectDate = {
  className?: string;
  styles?: CSSProperties;
  onChange: (date: string) => void;
  selectedDate: string;
  maxDate?: string;
  statusStyle?: boolean;
  statusStyleSMall?: boolean;
  alignRight?: boolean;
  disabled?: boolean;
  allYears?: boolean;
  minDate?: string;
};

const SelectTradeDate: FC<TSelectDate> = ({
  onChange,
  selectedDate,
  maxDate,
  statusStyle,
  styles,
  statusStyleSMall,
  alignRight,
  disabled,
  allYears = false,
  minDate,
}) => {
  const [calenderOpen, setCalenderOpen] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const inputRef = useRef<HTMLDivElement>(null);
  const calendarRef = useRef<HTMLDivElement>(null);

  const handleDateSelection = (_date: string) => {
    onChange(_date);
    // onChange(moment(_date).format("YYYY-MM-DD"));
    // onChange(moment(_date, "YYYY-MMM-DD").format("YYYY-MM-DD"));
    setCalenderOpen(false);
  };

  const toggleCalendar = () => {
    if (disabled) return;
    if (calenderOpen) {
      setCalenderOpen(false);
    } else {
      if (inputRef.current) {
        const rect = inputRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;
        const shouldOpenAbove = spaceBelow < 330 && spaceAbove > 330;

        const top = shouldOpenAbove
          ? rect.top + window.scrollY - 330 - 8
          : rect.bottom + window.scrollY + 8;

        const calendarWidth = 288;
        const rightMargin = 12;

        const left = alignRight
          ? rect.right + window.scrollX - (calendarWidth - rightMargin)
          : rect.left + window.scrollX + 16;

        setCalendarPosition({ top, left });
        setCalenderOpen(true);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const isInsideInput =
        inputRef.current && inputRef.current.contains(target);
      const isInsideCalendar =
        calendarRef.current && calendarRef.current.contains(target);

      if (!isInsideInput && !isInsideCalendar) {
        setCalenderOpen(false);
      }
    };

    const handleScroll = (event: Event) => {
      const target = event.target as Node;

      //  Close only if scroll happens outside the calendar dropdown
      if (
        calendarRef.current &&
        !calendarRef.current.contains(target) &&
        inputRef.current &&
        !inputRef.current.contains(target)
      ) {
        setCalenderOpen(false);
      }
    };

    if (calenderOpen) {
      document.addEventListener("mousedown", handleClickOutside, true);
      document.addEventListener("scroll", handleScroll, true);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [calenderOpen]);

  return (
    <>
      <div
        className="relative flex items-center justify-center shrink-0 w-full"
        ref={inputRef}
      >
        <div
          className={`flex bg-white items-center w-full fs-14 gap-2 mt_8 px-2 py-2 border br-10 text-sm justify-between ${
            disabled
              ? "border-gray opacity-50 cursor-not-allowed bg-gray-100"
              : "cursor-pointer"
          } ${statusStyle ? classes.heightInput : ""} ${
            statusStyleSMall ? classes.heightInputSmall : ""
          }`}
          onClick={toggleCalendar}
          style={styles}
        >
          <span className="color-blue">
            {selectedDate
              ? moment(selectedDate).format("DD-MMM-YYYY")
              : "Select Date"}
          </span>
          <img src={date_icon} alt="icon" className="w-4 h-4" />
        </div>
      </div>

      {calenderOpen &&
        ReactDOM.createPortal(
          <div
            ref={calendarRef}
            className=" h-80 z-[1000] bg-white shadow-md rounded-md absolute"
            style={{
              top: calendarPosition.top,
              left: calendarPosition.left,
            }}
          >
            {/* @ts-ignore */}
            <CalendarDayWidget
              date={selectedDate ? selectedDate : moment().format("YYYY-MM-DD")}
              calendarMode={"DAILY"}
              onSelectDate={(date: any) => {
                handleDateSelection(date);
              }}
              toDate={
                selectedDate ? selectedDate : moment().format("YYYY-MM-DD")
              }
              hideMargin={true}
              isSingleDate={true}
              maxDate={maxDate}
              allYears={allYears}
              minDate={minDate}
            />
            {/* <ONOCalendarV2
              mode={"DAILY"}
              onChangeDate={(fromDate, toDate, mode) => {
                handleDateSelection(fromDate);
              }}
              fromDate={selectedDate}
              toDate={selectedDate}
            /> */}
            {/* <Calender
              mode="single"
              currentDate={selectedDate}
              onChange={(data: any) => {
                handleDateSelection(data.date);
              }}
              maxDate={maxDate ?? moment().format("YYYY-MM-DD")}
            /> */}
          </div>,
          document.body
        )}
    </>
  );
};

export default SelectTradeDate;
